import $ from 'jquery';


const ToTop = function (breakPoint) {

  const $el = $('.js-stopLink') || null;

  // Observer Footer

  if (document.querySelector('.recruit-top') && window.innerWidth > breakPoint) {
    var area = document.querySelector('.l-footer');
    var options = {
    // rootMargin: "177px 0px 0px 0px",
    threshold: [0]
  }
  } else {
    var area = document.querySelector('.l-footer');
    var options = {
    rootMargin: "-63px 0px -63px 0px",
    threshold: [0]
  }
  }

  const cb = function (entries) {
    entries.forEach(function (entry) {
      if (entry.target.className.match('l-footer')) {
        if (entry.isIntersecting) {
          $el.addClass('is-static');
        } else {
          $el.removeClass('is-static');
        }
      }

    })

  }
  const observer = new IntersectionObserver(cb, options);
  observer.observe(area);

  $('#js-toTop').on('click', function (e) {
    e.preventDefault();
    $('body,html').animate({ scrollTop: 0 }, 500);
    return false;
  });

}

export default ToTop;


// WEBPACK FOOTER //
// ./src/recruit/js/toTop.js